export default "__VITE_ASSET__C6CI7_IF__"